import React, {useEffect} from "react";
import AiButton from "../ui/ai-button";
import {useArticleForm} from "../../hooks/use-article-form.hook";
import Tags from "./tags";
import {FormProvider} from "react-hook-form";
import RichTextFormField from "@common/components/forms/rich-text-form-field/rich-text-form-field";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import useModalWithData from "@common/hooks/use-modal-with-data";
import {AiConvertedArticleModalData} from "../ai-converted-article-modal";
import {useLoading} from "../../../core/hooks/use-loading.hook";
import {useArticleApi} from "../../../core/hooks/use-article-api";
import {createAiPreviewArticle} from "../../helpers/create-ai-preview-article";
import {AiErrorResponseModalData} from "../ai-error-response-modal";

const ArticleFormContent = () => {
    const {
        form,
        isEditMode,
        articleId,
        formData,
        applyAiContentToCurrentForm
    } = useArticleForm();
    const {showModal} = useModalWithData<AiConvertedArticleModalData>(ModalIds.ARTICLE_AI_CONVERTED_PREVIEW);
    const {showModal: showModalAiError} = useModalWithData<AiErrorResponseModalData>(ModalIds.ARTICLE_AI_ERROR_RESPONSE);
    const {startLoading, stopLoading, isLoading} = useLoading();
    const {improveArticleWithAi, error} = useArticleApi();

    const isImprovingArticle = isLoading("improveArticleAi");

    const clickConvertAiArticleHandler = async (): Promise<void> => {
        if (!isEditMode || !articleId) {
            return;
        }

        startLoading("improveArticleAi");
        try {
            const aiPayload = await improveArticleWithAi(articleId);
            const previewArticle = createAiPreviewArticle(aiPayload, articleId, formData);
            showModal({
                articleData: previewArticle,
                aiPayload,
                onAccept: (payload) => applyAiContentToCurrentForm(payload),
                acceptLabel: "Zaakceptuj zmiany"
            });
        } finally {
            stopLoading("improveArticleAi");
        }
    };

    useEffect(() => {
        if (error){
            showModalAiError({message: error, title: "Nie udało się przeredagować artykułu"});
        }
    }, [error]);

    return (
        <FormProvider {...form}>
            <div className="flex flex-col gap-[40px]">
                {isEditMode && (
                    <AiButton
                        onClick={clickConvertAiArticleHandler}
                        disabled={isImprovingArticle}
                        label={isImprovingArticle ? "AI przygotowuje wersję..." : undefined}
                    />
                )}
                <Tags/>
                <RichTextFormField
                    classNamePlaceholder="text-2xl font-semibold"
                    name="title"
                    placeholder="Dodaj tytuł artykułu..."
                />
                <RichTextFormField
                    classNamePlaceholder="text-base font-semibold"
                    name="summary"
                    placeholder="Dodaj streszczenie artykułu..."
                />
                <RichTextFormField
                    classNamePlaceholder="text-base font-normal "
                    name="content"
                    placeholder="Napisz lub wklej treść artykułu..."
                />
            </div>
        </FormProvider>
    )
}

export default ArticleFormContent
